module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/jcb-c7aa6e471f120e1c2748a19a91f85349.svg";